import { admin } from './admin'
import { customers } from './customers'
import { documents } from './documents'
import { tickets } from './tickets'
import { categories } from './categories'
import { services, sla } from './services'
import { rsp } from './rsp'

import { files } from './files'

import { schedule, booking, lots } from './schedule'

import { settings } from './settings'
import { pineapple } from './pineapple'
import { dictionary } from './dictionary'

import { messages } from './messages'

import { reports } from './reports'

import { building } from './building'

const polygons = {
  kml: 'polygons-converted-to-kml'
}

export {
  admin,
  customers,
  documents,
  tickets,
  categories,
  services,
  sla,
  rsp,
  schedule,
  booking,
  lots,

  settings,
  dictionary,
  messages,
  building,

  pineapple,

  reports,

  files,
  polygons
}
